module.exports = __webpack_public_path__ + "img/graph-down.e3a9eb2c.svg";